<div class="view">
  <div class="settings" *ngIf="settingsOpen">
    <div class="settings__body">
      <div class="settings__preview">
        <oc-video-preview></oc-video-preview>
      </div>
      <div class="settings__panel">
        <div class="settings__header">
          <h2>Video and Audio setup</h2>
          <p>Please setup and check your video and audio devices</p>
        </div>
        <div class="settings__content">
          <oc-mediasettings></oc-mediasettings>
        </div>
        <div class="settings__footer">
          <button type="button" class="OCUIbutton OCUIbutton--slave" (click)="closeSettings()">Close</button>
          <button type="button" class="OCUIbutton OCUIbutton--action" (click)="closeSettings()">Done</button>
        </div>
      </div>
    </div>
  </div>

  <user-video (onEvent)="handleUserVideoEvent($event)"></user-video>

  <div *ngIf="error" class="overlay">
    <h4>{{ error.header }}</h4>
    <p>{{ error.text }}</p>
    <img class="spinner" src="/assets/img/spinner_001.svg" />
    <br />
    <br />
    <br />
    <br />
    <button class="OCUIbutton OCUIbutton--slave">Restart conference</button>
  </div>

  <div *ngIf="disabled" class="overlay">
    <h4>Looks like you have no internet connection</h4>
    <p>Please check your internet connection</p>
    <p>Trying to reconnect...</p>
    <img class="spinner" src="/assets/img/spinner_001.svg" />
    <br />
    <br />
    <br />
    <br />
    <button class="OCUIbutton OCUIbutton--slave">Restart</button>
  </div>
</div>
